import React from 'react';
import { useFormik } from 'formik';
import { postDataToTheServer, putDataToTheServer } from '../../../helpers/api';
import AppURL from '../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../constants/Toast';
import Container from '../../../constants/Container';
import SecHeading from '../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../constants/InputTextBox';
import { handleSelectBox } from '../../../helpers/handleChange';
import { EndBaseLine } from '../../../constants/AppSpace';
import { Button } from '../../../constants/Button';
import SelectInputBox from '../../../constants/SelectInputBox';
import { YesNoOptions } from '../../../constants/Options';

interface MargaToleAddFormViewProps {
    handleFormSuccess: () => void;
}
const TapSizeCreateView: React.FC<MargaToleAddFormViewProps> = ({ handleFormSuccess }) => {
    const initialValues = {
        size_name: "",
        tap_size: "",
        remarks: "",
        active: "",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: toleValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("size_name", values.size_name);
            formData.append("tap_size", values.tap_size);
            formData.append("remarks", values.remarks);
            formData.append("active", values.active==="1"?"1":"0");
            try {
                await postDataToTheServer(AppURL.FrontOfficeURL + 'front/tap/size/create/list/view/', formData).then((res) => {
                    if (res?.status === 201) {
                        handleFormSuccess();
                        action.resetForm();
                        ToastSuccess({ message: res?.message });
                    } else if (res?.status === 400) {
                        ToastWarning({ message: res?.message?.tole_name });
                    }
                    else {
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Tap Size Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='size_name'
                            label='Tap Size Name'
                            handleChange={handleChange}
                            value={values.size_name}
                            error={errors.size_name}
                            handleBlur={handleBlur}
                            touched={touched.size_name}
                            required={true}
                            placeholder='Small | Medium | Largest'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='number'
                            name='tap_size'
                            label='Tap Size Name'
                            handleChange={handleChange}
                            value={values.tap_size}
                            error={errors.tap_size}
                            handleBlur={handleBlur}
                            touched={touched.tap_size}
                            required={true}
                            placeholder='2.0'
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='remarks'
                            label='Remarks'
                            handleChange={handleChange}
                            value={values.remarks}
                            error={errors.remarks}
                            handleBlur={handleBlur}
                            touched={touched.remarks}
                            required={false}
                            placeholder='Remarks'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label="Active"
                            options={YesNoOptions}
                            name='active'
                            required={true}
                            placeholder='Select tap status'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            value={values.active}
                            touched={touched.active}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default TapSizeCreateView